import React, { FC } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import type { IUser } from '../../model/user';
import type { IProject } from '../../model/project';
import type { ITool } from '../../model/tool';
import { observer } from 'mobx-react-lite';
import { isStateTreeNode, onSnapshot } from 'mobx-state-tree';
import { UserController } from '../../controllers/userController';
import { UserProjectTabs } from '../user-project-tabs/user-project-tabs';
import { LabelHeader, usePrompt } from '@yakoffice/shared-components';
import styles from '../../routes/users/forms/user-form.module.sass';

interface PropsType {
    projects: IProject[];
    tools: ITool[];
    user: IUser;
    updateCallbackTrigger: (clearActiveUser?: boolean) => void;
}

export const UserForm: FC<PropsType> = observer((props: PropsType) => {

    const [pageEdited, setPageEdited] = usePrompt('You have unsaved changes. Are you sure you want to leave?', false);
    // Flush sync to prevent batching which prevents immediate rerender
    const controller = UserController({
        setUserEditStatus: setPageEdited,
        updateCallbackTrigger: props.updateCallbackTrigger
    });

    if (isStateTreeNode(props.user))// So can pass in mock....
        onSnapshot(props.user, () => setPageEdited(true));

    const userEmailChange = (e: any) => {
        props.user.updateUserEmail(e.target.value);
    };

    const userAdminChange = (e: any) => {
        props.user.updateUserAdmin(e.target.value === 'true');
    };

    return (
        <div className={styles.userForm}>
            <Row>
                <Col md="6">
                    <Form.Group>
                        <Form.Label htmlFor="userEmail" className="">
                            <LabelHeader className="large"><i
                                className="fas fa-at" /> Email</LabelHeader>
                        </Form.Label>
                        <Form.Control type="email" id="userEmail" placeholder={props.user.email}
                                      defaultValue={props.user.email}
                                      disabled={!props.user.isNew}
                                      onChange={userEmailChange} />
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group>
                        <Form.Label><LabelHeader className="large"><i className="fas fa-globe-europe" /> User
                            Administrator</LabelHeader></Form.Label>
                        <Form.Select defaultValue={props.user.isAdmin.toString()} onChange={userAdminChange}>
                            <option hidden>Select...</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col>
                    <UserProjectTabs projects={props.projects} tools={props.tools} user={props.user} />
                </Col>
            </Row>
            <div className={styles.footer}>
                {pageEdited &&
                    <Button className={styles.saveUserButton} onClick={controller.saveUser} disabled={!pageEdited}
                            data-testid="btnSave">Save User</Button>}
                {!props.user.isNew &&
                    <Button className={styles.deleteUserButton} onClick={controller.deleteUser}>Delete User</Button>}

            </div>
        </div>
    );
});

export default UserForm;
